export enum Colors {
    Deverto = "#eb6e1a",
}
